import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';
import { Ortak } from '../../../providers/ortak';
declare var cordova: any;

@Component({
  selector: 'page-alacakli-hesaplar-report',
  templateUrl: 'alacakli-hesaplar-report.html',
})
export class AlacakliHesaplarReportPage {
  AlacakliListesi = [];
  AlacakliListesi2 = [];
  aranan = "";
  toplamalacak: number = 0;
  take: number = 5000;
  geneltoplam:number=0;
  istektarihi: any;
  cihazid = "";
  musteriGrupListesi = [];
  secilengrup: number = 1;
  ServerParamet: any = { FirmaAdi: "", FirmaTelefonu: "", FirmaAdres: "", FirmaEmail: "", FirmaWeb: "", FirmaVD: "", FirmaVN: "" };
  constructor(public navCtrl: NavController,
    public bllOrtak: BllOrtak,
    public ortak: Ortak,
    public viewCtrl: ViewController,
    public navParams: NavParams) {
    this.bllOrtak.islemWithoutPost("ParametreleriVer", "", false).then(a => {
      var sonuc = <any>a;
      this.ServerParamet = sonuc.SonucObject;
    });
    this.cihazid = this.ortak.storageCihazBilgisiGetir.ID;
    this.istektarihi = this.ortak.storageGunTarihiGetir;
    this.istektarihi = this.ortak.tarih(this.istektarihi);
  }

  ionViewDidLoad() {
    this.GrupGetir();
    this.cariAra(null);
  }
  cariAra(e) {
    this.geneltoplam=0;
this.toplamalacak=0;
    var formData = new FormData();
    formData.append("aranan", this.aranan);
    formData.append("grupid", this.secilengrup.toString());
    formData.append("take", this.take.toString());
    this.bllOrtak.islem(formData, "AlacakliCariHesaplar", "", false).then(a => {
      var sonuc = <any>a;
      this.AlacakliListesi = sonuc.SonucObject;
      this.AlacakliListesi.forEach(element => {
        element.Bakiyesi = element.Bakiyesi * -1;
        this.toplamalacak += element.Bakiyesi;
        this.geneltoplam=this.toplamalacak;
      });
      this.AlacakliListesi2 = this.AlacakliListesi.filter(a => a.Bakiyesi != 0);
      console.log("cihaz",this.ortak.storageCihazBilgisiGetir.ID);
    })
  }
  GrupGetir() {
    this.bllOrtak.islemWithoutPost("CariGrupListesi", "", false).then(a => {
      var sonuc = <any>a;
      this.musteriGrupListesi = sonuc.SonucObject;
    })
  }

  cariler(e) {
    if (e.keyCode == 13) {
      this.cariAra(e);
    }
  }
  pdf() {
    var html = "<html><head>  <link href='https://stackpath.bootstrapcdn.com/bootstrap/4.1.1/css/bootstrap.min.css' rel='stylesheet'></head><body>" +
      "<table style='width: 100%;border-bottom:1px solid lightgray;margin-bottom:30px'>" +
      "<tbody>" +
      "<tr>" +
      "<td style'width: 41.8357%;'>&nbsp;</td>" +
      "<td style='width: 53.1643%;'><span style='float:left;width:100%;text-align:right'> {{ServerParamet.FirmaAdres}}</span></td>" +
      "</tr>" +
      "<tr>" +
      "<td style='width: 41.8357%;'>&nbsp;<span style='color: #cc0000;'><strong style='font-size: 30px;'><strong>{{ServerParamet.FirmaAdi}}</strong></strong></span></td>" +
      "<td style='width: 53.1643%;'><span style='float:left;width:100%;text-align:right'> {{ServerParamet.FirmaTelefonu}}</span></td>" +
      "</tr>" +
      "<tr>" +
      "<td style='width: 41.8357%;'>&nbsp;</td>" +
      "<td style='width: 53.1643%;'><span style='float:left;width:100%;text-align:right'> {{ServeParamet.FirmaWeb}}</span></td>" +
      "</tr>" +
      "</tbody>" +
      "</table>" +
      "<div class='card text-center'>" +
      "<div class='card-footer text-muted'>" +
      "Alacaklı Hesaplar Listesi" +
      "</div>" +
      "</div><hr/>" +
      "<table class='table table-striped table-bordered table-hover'>" +
      "<thead>" +
      "<tr>" +
      "<th>Cari Hesap Adı</th>" +
      "<th>Adres</th>" +
      "<th>Gsm</th>" +
      "<th>Alacağı</th>" +
      "</tr>" +
      "</thead>" +
      "<tbody>";
    this.AlacakliListesi2.forEach(extre => {
      html = html + "<tr>";
      html = html + "<td>" + extre.Definition_ + "</td>";
      html = html + "<td>" + extre.Adres + "</td>";
      html = html + "<td>" + extre.Gsm + "</td>";
      html = html + "<td>" + extre.Bakiye + "</td>";
      html = html + "</tr>";
    });
    html = html + "<table style='width:100%'>";
    html = html + "<tr>";
    html = html + "<td>";
    html = html + "<span style='float:left;width:100%;text-align:right'>Toplam Borç: " + this.toplamalacak + " </span>";
    html = html + "</td>";
    html = html + "</tr>";
    html = html + "</table>";
    html = html + "</body></html>";
    html = html + "</tbody></table></body></html>";
    cordova.plugins.pdf.htmlToPDF({
      data: html,
      documentSize: "A4",
      landscape: "portrait",
      type: "share"
    },
      (sucess) => console.log('sucess: ', sucess),
      (error) => console.log('error:', error));
  }
  excel() {

    var data = [];
    this.AlacakliListesi2.forEach(element => {
      data.push({
        "Cari Hesap Adı": element.Definition_,
        "Adres": element.Addr1,
        "Gsm No": element.GsmNumber,
        "Alacağı": element.Bakiyesi
      })
    });
    this.ortak.ExportExcel(data, "Alacaklı Hesaplar-" + this.istektarihi).then(a => {
    }).catch(x => {
    });
  }
  kapat() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/Raporlars/alacakli-hesaplar-report/alacakli-hesaplar-report.ts